import React from 'react';
import PropTypes from 'prop-types';

import {
  ResponsiveContainer,
  PieChart as Chart,
  Pie,
  Cell,
  Tooltip,
} from 'recharts';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { alpha, useTheme } from '@mui/material/styles';

import getChartColors from './chartColors';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload || !payload.length) return null;

  const item = payload[0];

  return (
    <Paper
      elevation={3}
      sx={(theme) => ({
        p: 2,
        minWidth: 160,
        backgroundColor: 'var(--color-surface-elevated)',
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2">
          {item.name}
        </Typography>

        <Typography variant="body2" fontWeight={600}>
          {item.value}
        </Typography>
      </Box>
    </Paper>
  );
};

const PieChart = ({ data = [], dataKey = 'value', nameKey = 'name' }) => {
  const theme = useTheme();
  const colors = getChartColors(theme, data.length || 5);

  return (
    <ResponsiveContainer width="100%" height={350}>
      <Chart>
        <Tooltip content={<CustomTooltip />} />

        <Pie
          data={data}
          dataKey={dataKey}
          nameKey={nameKey}
          cx="50%"
          cy="50%"
          outerRadius={120}
          paddingAngle={2}
          stroke={alpha(theme.palette.divider, theme.palette.mode === 'dark' ? 0.9 : 0.75)}
          strokeWidth={1}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={colors[index % colors.length]}
            />
          ))}
        </Pie>
      </Chart>
    </ResponsiveContainer>
  );
};

PieChart.propTypes = {
  data: PropTypes.array,
  dataKey: PropTypes.string,
  nameKey: PropTypes.string,
};

export default PieChart;
